import type { AjaxResponse } from 'rxjs';
import { get } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import { getMeta } from '@helpcenter/meta';
import { APOLLO_STARGATE_CONTEXT_ROOT } from 'rest/constants';
import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import invariant from 'tiny-invariant';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import type { FetchArticleSpaceKeyResponse } from 'rest/models/types';
interface FetchArticleSpaceKeyParams {
    articleId: string;
}

interface FetchArticleSpaceKeyAjaxResponse extends AjaxResponse {
    response: FetchArticleSpaceKeyResponse;
}
const fetchArticleSpaceKeyEndpoint = (articleId: string) => {
    const activationId = getMeta('activation-id');
    invariant(activationId, 'Activation ID not available');
    return `${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/article/${articleId || ''}`;
};
export const fetchArticleSpaceKey = ({
    articleId,
}: FetchArticleSpaceKeyParams): Observable<FetchArticleSpaceKeyResponse> => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(fetchArticleSpaceKeyEndpoint(articleId), { 'Content-Type': 'application/json' })
        .map(({ response }: FetchArticleSpaceKeyAjaxResponse) => response)
        .catch((e: AjaxError) => {
            trackError('article.space.key.fetch.failed', {}, e);
            return Observable.throw(e);
        });
};
